import React from "react";
import { Box, Typography } from "@mui/material";

function termAndPolicy() {
  return (
    <Box
      marginX="0.5rem"
      marginY="0.5rem"
      p="0.5rem"
      sx={{
        backgroundColor: "#FFFFFF",
      }}
      boxShadow={3}
      alignSelf="center"
    >
      {/* <Typography variant="h4" sx={{ margin: "1rem" }}>
        利用規約
      </Typography>
      <Typography variant="body1" align="left" sx={{ marginTop: "1rem" }}>
        <ul>
          <li>
            当サイトは、
            <a href="https://wikiwiki.jp/vspo/">ぶいすぽ非公式wiki</a>
            のための、<a href="https://wikiwiki.jp/sample/">wikiwikiのルール</a>
            に則った書式を出力するwebアプリです。意見・要望等は
            <a href="https://twitter.com/svet_gg">作者</a>までお願いします。
          </li>
        </ul>
      </Typography> */}
      <Typography variant="h4" sx={{ margin: "1rem" }}>
        プライバシーポリシー
      </Typography>
      <Typography variant="body1" align="left" sx={{ marginTop: "1rem" }}>
        <ul>
          <li>
            当サイトでは、利用状況の把握のためにGoogle
            Analyticsを使用しています。Google
            Analyticsは、データ収集のためCookieを使用しています。お使いのブラウザの設定により、Cookieを無効化することで、このデータ収集を拒否できます。
            <a href="https://www.google.com/intl/ja/policies/privacy/partners/">
              「GOOGLE のサービスを使用するサイトやアプリから収集した情報の
              GOOGLE による使用」
            </a>
            もご覧ください。
          </li>
        </ul>
      </Typography>
    </Box>
  );
}

export default termAndPolicy;
